import _ from 'lodash'
import type {CssValue} from '../../constants'

const POSSIBLE_BOOLEAN_VALUES = {
    true: true,
    false: false
}

const serialize = (val: any): CssValue | undefined => (_.isBoolean(val) ? val.toString() : undefined)

const deserialize = (rule: CssValue): boolean | undefined =>
    (POSSIBLE_BOOLEAN_VALUES as Record<string, boolean>)[rule as string]

export default {
    serialize,
    deserialize
}
